import { connect } from 'react-redux';

import { hideTrolleyInfoBox } from 'apps/subscriptions/actions/subscriptions';

import SubscriptionsTrolleyInfoBoxContainer from '../components/SubscriptionsTrolleyInfoBoxContainer';

export default connect(
  (state) => ({
    showTrolleyInfoBox: state.subscriptions.showTrolleyInfoBox,
  }),
  { onDismiss: hideTrolleyInfoBox }
)(SubscriptionsTrolleyInfoBoxContainer);
